import React from "react";

const Email = ({email}) => {

    return <a href={'mailto:' + email} className='emaillink'>{email}</a>

}

export default Email;
